import I18n from '@i18n';
import styled from '@src/styled-components';
import { Button } from 'antd';
import React from 'react';

const ButtonGroup = Button.Group;

type PropsType = {
    label: string,
    buttons: {
        text: {
            active: string,
            deactive: string,
            all: string,
        }
    }
    onClick: Function;
    disabled?: boolean;

    ticketStatus?: boolean;
    curTicketStatus?: number;
    ticketGroupStatus?: boolean;
    orderBy?: boolean;
    auditedsFilter?: boolean;
    auditorsFilter?: boolean;
};

class FilterComponent extends React.Component<PropsType> {

    render() {
        const { onClick, buttons, disabled, label, curTicketStatus, ticketGroupStatus, orderBy, auditedsFilter, auditorsFilter } = this.props;
        return (
            <FilterGroup>
                {
                    (!this.props.ticketStatus && !ticketGroupStatus && !orderBy && !auditedsFilter && !auditorsFilter) &&
                    <div>
                        <h2 style={{ fontSize: '20px' }}>{I18n.l(label)}</h2>
                        <ButtonGroup size="large">
                            <Button onClick={() => { onClick(false) }} className={disabled === false ? 'active' : ''} >{I18n.l(buttons.text.active)}</Button>
                            <Button onClick={() => { onClick(true) }} className={!disabled ? '' : 'active'}>{I18n.l(buttons.text.deactive)}</Button>
                            <Button onClick={() => { onClick(undefined) }} className={disabled === undefined ? 'active' : ''}>{I18n.l(buttons.text.all)}</Button>
                        </ButtonGroup>
                    </div>
                }
                {
                    (this.props.ticketStatus != undefined) &&
                    <div>
                        <h2>{I18n.l('form.labels.filterTicketByStatus')}</h2>
                        <ButtonGroup size="large">
                            <Button onClick={() => { onClick(4) }} className={curTicketStatus === 4 ? 'active' : ''}>{I18n.l('global.ticket.status.inprogress')}</Button>
                            <Button onClick={() => { onClick(3) }} className={curTicketStatus === 3 ? 'active' : ''}>{I18n.l('global.ticket.status.error')}</Button>
                            <Button onClick={() => { onClick(2) }} className={curTicketStatus === 2 ? 'active' : ''}>{I18n.l('global.ticket.status.done')}</Button>
                            <Button onClick={() => { onClick(undefined) }} className={curTicketStatus === undefined ? 'active' : ''} >{I18n.l('form.labels.all')}</Button>
                        </ButtonGroup>
                    </div>
                }
                {!!this.props.ticketGroupStatus && this.props.ticketGroupStatus == true && (
                    <div>
                        <h2>{label}</h2>
                        <ButtonGroup size="large">
                            <Button onClick={() => { onClick(10) }} className={curTicketStatus === 10 ? 'active' : ''}>{I18n.l('history.disable')}</Button>
                            <Button onClick={() => { onClick(4) }} className={curTicketStatus === 4 ? 'active' : ''}>{I18n.l('global.ticket.status.inprogress')}</Button>
                            <Button onClick={() => { onClick(2) }} className={curTicketStatus === 2 ? 'active' : ''}>{I18n.l('global.ticket.status.done')}</Button>
                            <Button onClick={() => { onClick(undefined) }} className={curTicketStatus === undefined ? 'active' : ''} >{I18n.l('form.labels.all')}</Button>
                        </ButtonGroup>
                    </div>
                )}
                {!!this.props.orderBy && this.props.orderBy == true && (
                    <div>
                        <h2>{label}</h2>
                        <ButtonGroup size="large">
                            <Button onClick={() => { onClick(undefined) }} className={curTicketStatus === undefined ? 'active' : ''} >{I18n.l(this.props.buttons.text.all)}</Button>
                            <Button onClick={() => { onClick(1) }} className={curTicketStatus === 1 ? 'active' : ''}>{I18n.l(this.props.buttons.text.deactive)}</Button>
                        </ButtonGroup>
                    </div>
                )}
                {!!this.props.auditedsFilter && this.props.auditedsFilter == true && (
                    <div>
                        <h2>{label}</h2>
                        <ButtonGroup size="large">
                            <Button onClick={() => { onClick(undefined) }} className={curTicketStatus === undefined ? 'active' : ''} >{I18n.l(this.props.buttons.text.all)}</Button>
                            <Button onClick={() => { onClick(1) }} className={curTicketStatus === 1 ? 'active' : ''}>{I18n.l(this.props.buttons.text.deactive)}</Button>
                        </ButtonGroup>
                    </div>
                )}
                {!!this.props.auditorsFilter && this.props.auditorsFilter == true && (
                    <div>
                        <h2>{label}</h2>
                        <ButtonGroup size="large">
                            <Button onClick={() => { onClick(undefined) }} className={curTicketStatus === undefined ? 'active' : ''} >{I18n.l(this.props.buttons.text.all)}</Button>
                            <Button onClick={() => { onClick(2) }} className={curTicketStatus === 2 ? 'active' : ''}>{I18n.l(this.props.buttons.text.active)}</Button>
                            <Button onClick={() => { onClick(1) }} className={curTicketStatus === 1 ? 'active' : ''}>{I18n.l(this.props.buttons.text.deactive)}</Button>
                        </ButtonGroup>
                    </div>
                )}
            </FilterGroup>
        )
    }
}

export default FilterComponent;

const FilterGroup = styled.div`
    margin-bottom: 50px;
    button {
        font-size: 15px;
    }
`;